import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0275ed62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-loader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point point-1" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point point-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point point-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "quick-fade" }, {
    default: _withCtx(() => [
      (_ctx.loadingAfterDebounce)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["loader", { light: _ctx.light, absolute: _ctx.absolute }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Icon, { name: "melati-outline" }),
              _hoisted_2,
              _hoisted_3,
              _hoisted_4
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}